import {  Redirect, Route, Switch } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import Login from "../telas/login/Login";
import Home from "../telas/home/Home";
import AccessHistory from "../telas/access-history/AccessHistory";
import ErrorHistory from "../telas/error-history/ErrorHistory";
import ChangePassword from "../telas/change-password/ChangePassword";
import SystemParameter from "../telas/system-parameters/SystemParameter";
import UserControl from "../telas/user-control/UserControl";
import Role from "../telas/role/Role";
import Layout from "./layouts/Layout";
import ProgramaRole from "../telas/program-role/ProgramRole"
import Product from "../telas/Product/Product";
import NfeImport from "../telas/NfeImport/NfeImport";
import RelatorioEntregas from "../telas/relatorio-entregas/RelatorioEntregas";
import MaterialPicking from "../telas/MaterialPicking/MaterialPicking";


const Routes = () => (
    <Switch>
        <Route exact path="/">
            <Redirect to="/login" />
        </Route>

        <Route exact path="/login" component={Login} />

        <Layout>
            <PrivateRoute
                exact
                path="/home"
                component={Home}
            />

            <PrivateRoute
                exact
                path="/change-password"
                component={ChangePassword}
            />

            <PrivateRoute
                exact
                path="/userControl"
                component={UserControl}
            />

            <PrivateRoute
                exact
                path="/access-history"
                component={AccessHistory}
            />

            <PrivateRoute
                exact
                path="/error-history"
                component={ErrorHistory}
            />

            <PrivateRoute
                exact
                path="/system-parameters"
                component={SystemParameter}
            />

            <PrivateRoute
                exact
                path="/profile"
                component={Role}
            />

            <PrivateRoute
                exact
                path="/program-role"
                component={ProgramaRole}
            />

            <PrivateRoute
                exact
                path="/frmCadProduto"
                component={Product}
            />

            <PrivateRoute
                exact
                path="/conRelEntrega"
                component={RelatorioEntregas}
            />

            <PrivateRoute
                exact
                path="/nfeImport"
                component={NfeImport}
            />

            <PrivateRoute
                exact
                path="/frmMaterialPicking"
                component={MaterialPicking}
            />

        </Layout>
    </Switch>
);

export default Routes;
